import React, { useEffect, useState, useCallback } from "react";
import Hero from '../components/Carousel/Hero';
import Feature from '../components/Feature/Feature';
import Cta from '../components/cta/Cta';
import VideoCardSection from "../components/testimonial/testimonial";

function HomePage() {
  const [zoomLevel, setZoomLevel] = useState(1);

  // Throttled resize handler to improve performance
  const handleZoomChange = useCallback(() => {
    const ratio = window.outerWidth / window.innerWidth;
    setZoomLevel(ratio);
  }, []);

  // Throttle function to limit how often resize handler runs
  const throttle = (func, delay) => {
    let timeoutId;
    let lastExecTime = 0;
    return function (...args) {
      const currentTime = Date.now();
      
      if (currentTime - lastExecTime > delay) {
        func.apply(this, args);
        lastExecTime = currentTime;
      } else {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(this, args);
          lastExecTime = Date.now();
        }, delay - (currentTime - lastExecTime));
      }
    };
  };

  // Load AOS lazily so it stays out of the entry bundle and off the critical path
  useEffect(() => {
    let cancelled = false;

    Promise.all([import('aos'), import('aos/dist/aos.css')]).then(([{ default: AOS }]) => {
      if (cancelled) return;
      AOS.init({
        duration: 800,
        once: true,
        offset: 100,
        easing: 'ease-out-cubic'
      });
    });

    return () => {
      cancelled = true;
    };
  }, []);

  // Handle zoom detection with throttling
  useEffect(() => {
    const throttledZoomChange = throttle(handleZoomChange, 100);
    
    // Initial call
    handleZoomChange();
    
    window.addEventListener("resize", throttledZoomChange);
    return () => {
      window.removeEventListener("resize", throttledZoomChange);
    };
  }, [handleZoomChange]);

  return (
    <div className={`${zoomLevel < 0.3 ? "mx-auto container" : ""}`}>
      <Hero />
      
      <div 
        data-aos="fade-up" 
        data-aos-delay="100"
        data-aos-duration="600"
      >
        <Feature />
      </div>
      
      <div 
        data-aos="fade-up" 
        data-aos-delay="200"
        data-aos-duration="600"
      >
        <VideoCardSection />
      </div>
      
      <div 
        data-aos="fade-up" 
        data-aos-delay="300"
        data-aos-duration="600"
      >
        <Cta />
      </div>
    </div>
  );
}

export default HomePage;
